import type { LucideIcon } from 'lucide-react'
import { Bot, ClipboardList, RefreshCw, Zap } from 'lucide-react'
import {
	type I18nKeys,
	useTranslation,
} from '@/shared/core/hooks/use-translation/use-translation.ts'
import { FeatureBadge } from '@/teams/portfolio/components/section/home-section/ai-indicator/feature-badge/feature-badge.tsx'
import '@/teams/portfolio/components/section/home-section/ai-indicator/ai-banner/ai-banner.scss'

interface AiBannerProps {
	className?: string
}

interface Feature {
	icon: LucideIcon
	labelKey: I18nKeys
}

export function AiBanner({ className }: Readonly<AiBannerProps>) {
	const { t } = useTranslation()
	const classes = ['ai-banner', className].filter(Boolean).join(' ')

	const features: Feature[] = [
		{
			icon: Bot,
			labelKey: 'portfolio.section.aiIndicator.feature.agents' as I18nKeys,
		},
		{
			icon: Zap,
			labelKey: 'portfolio.section.aiIndicator.feature.skills' as I18nKeys,
		},
		{
			icon: ClipboardList,
			labelKey: 'portfolio.section.aiIndicator.feature.plans' as I18nKeys,
		},
		{
			icon: RefreshCw,
			labelKey: 'portfolio.section.aiIndicator.feature.hooks' as I18nKeys,
		},
	]

	return (
		<div className={classes} data-testid='ai-banner'>
			<h2 className='ai-banner__title'>
				{t('portfolio.section.aiIndicator.title' as I18nKeys)}
			</h2>
			<div className='ai-banner__features'>
				{features.map((feature) => (
					<FeatureBadge
						icon={feature.icon}
						key={feature.labelKey}
						labelKey={feature.labelKey}
					/>
				))}
			</div>
			<p className='ai-banner__tagline'>
				{t('portfolio.section.aiIndicator.tagline' as I18nKeys)}
			</p>
		</div>
	)
}
